<template>
  <Modal v-if="showModalDiscardAuthentication" @close="$emit('closeModal')">
    <div class="discardAuthentication">
      <div class="discardAuthentication__header">
        <span class="discardAuthentication-title">
          {{ $t('discardAuthentication') }}
        </span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="discardAuthentication__body">
        <p class="text">
          {{ $t('discardAuthenticationText') }}
        </p>
      </div>
      <div class="discardAuthentication__buttons">
        <Button
          variant="filled"
          :title="$t('exit')"
          @click="$emit('discardAuthentication')"
        />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DiscardAuthentication',
  props: ['showModalDiscardAuthentication', 'reference']
})
export default class DiscardAuthentication extends Vue {}
</script>

<style lang="scss">
.discardAuthentication {
  width: 460px;
  height: 100%;
  padding: 24px;
  .discardAuthentication__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .discardAuthentication-title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .discardAuthentication__body {
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
}
</style>
